import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { CssFlex } from "styles/helpers/layout";

export const StyledSectionCollapsible = styled(CssFlex)<ThemeProps>`
  cursor: pointer;
`;
